import { createSlice } from '@reduxjs/toolkit'
import add from './reducers/addActivity'
import remove from './reducers/removeActivity'
import search from './reducers/searchActivities'
import startSearch from './reducers/startSearch'
import finishSearch from './reducers/finishSearch'

export const slice = createSlice({
  name: 'activities',
  initialState: {
    activities: {},
    activitiesCount: 0,
    activitySearchValue: '',
    activitiesFilter: 'all'
  },
  reducers: {
    addActivity: add,
    addActivities: (state, action) => {
      const activities = action.payload
      activities.forEach((activity) => {
        add(state, { payload: activity })
      })
    },
    removeActivity: remove,
    searchActivities: search,
    startActivitiesSearch: startSearch,
    finishActivitiesSearch: finishSearch,
    restoreActivityVisibility: (state) => {
      for (const activityKey in state.activities) {
        state.activities[activityKey].visible = true
      }
    },
    setFilterType: (state, action) => {
      state.activitiesFilter = action.payload
    }
  },
})

export const { addActivity, addActivities, removeActivity, restoreActivityVisibility, searchActivities, startActivitiesSearch, finishActivitiesSearch, setFilterType } = slice.actions
export default slice.reducer
